import { Autocomplete, TextField } from "@mui/material";
import React from "react";

interface Props {
  options: {
    id: number;
    label: string;
  }[];
  placHolder: string;
}

export default function CustomAutoComple({ options, placHolder }: Props) {
  return (
    <Autocomplete
      disablePortal
      id="combo-box-demo"
      options={options}
      sx={{
        "& .MuiInputBase-root": {
          paddingRight: "8px !important",
        },
        "& .MuiAutocomplete-endAdornment": {
          position: "static",
        },
        "& .MuiInputBase-input": {
          height: 15,
        },
      }}
      renderInput={(params) => {
        const newParams = {
          ...params,
          InputProps: {
            ...params.InputProps,
            placeholder: placHolder,
          },
        };

        return <TextField {...newParams} label="" />;
      }}
    />
  );
}
